import { GeneratedMockup } from 'types/mockups';
import { create } from 'zustand';

export type MockupState = {
  mockups: Partial<Record<string, GeneratedMockup>>;
  isLoading: boolean;
  generationFailed: boolean;
};

type Store = MockupState & {
  setMockups: (mockups: MockupState['mockups']) => void;
  setIsLoading: (isLoading: MockupState['isLoading']) => void;
  setGenerationFailed: (generationFailed: MockupState['generationFailed']) => void;
};

export const useMockupStore = create<Store>()((set) => ({
  mockups: {},
  isLoading: false,
  generationFailed: false,
  setMockups: (mockups) => set({ mockups }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setGenerationFailed: (generationFailed) => set({ generationFailed }),
}));
